export const GET_SIZES = "GET_SIZES";
export const GET_SIZE = "GET_SIZE";
export const ADD_SIZE = "ADD_SIZE";
export const DELETE_SIZE = "DELETE_SIZE";
export const UPDATE_SIZE = "UPDATE_SIZE";
